import { ResourceManager } from "@/components/ResourceManager";
import { CATEGORY_KEYS } from "@/lib/categories";
import { Sparkles } from "lucide-react";

const fields = [
  { name: "category", label: "Category", type: "select", options: CATEGORY_KEYS, required: true },
  { name: "title", label: "Title", type: "text", required: true },
  { name: "description", label: "Description", type: "textarea", rows: 4, table: false },
  { name: "image_path", label: "Image", type: "image" },
  { name: "order", label: "Order", type: "number" },
];

export default function ProgramsAdmin() {
  return <ResourceManager title="Activities & Programs" eyebrow="Content" endpoint="programs" fields={fields} hasPublish icon={Sparkles} />;
}
